import Vue from 'vue'
import Vuex from 'vuex'
import modulePaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'
import DashboardResource from "@/store/DashboardResource";
import HelpdeskTicket from "@/store/HelpdeskTicket";
import FormSeen from "@/store/FormSeen";
import ProductBulkEdit from "@/store/ProductBulkEdit";
import Statistic from "@/store/Statistic";

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        DashboardResource,
        HelpdeskTicket,
        FormSeen,
        ProductBulkEdit,
        ...modulePaths,
        Statistic,
    }
})